<template>
  <div class="returnJkPage" v-if="!showLoad">
    <div class="claimDetailLists dzfp">
      <h4 class="title">到账分配</h4>
    </div>
    <ul class="listUl">
      <li class="listLi dis_flex justy_space">
        <van-cell-group class="baseNone baseSalary dwBox">
          <van-field
            v-model="invoiceData.amount"
            readonly
            class="ggInput"
            input-align="right"
            label="借款金额（元）："
          />
          <div class="ljdz">
            <van-field
              v-model="invoiceData.amountTotal"
              readonly
              :is-link="invoiceData.amountTotal > 0"
              class="ggInput"
              input-align="right"
              @click="jumpUrl"
              label="累计还款金额（元）："
            />
          </div>
          <van-field
            v-model="invoiceData.amountRemain"
            readonly
            class="ggInput"
            input-align="right"
            label="未归还金额（元）："
          />
          <van-field
            v-if="mode == 'add'"
            type="number"
            @input="moneyOnceChange"
            v-model="invoiceData.onceAmount"
            :readonly="!editType"
            clearable
            :required="editType"
            class="ggInput"
            input-align="right"
            :placeholder="editType ? '请输入...  ' : ''"
            label="本次归还金额（元）："
          />
          <van-field
            v-if="mode == 'add'"
            label="到账时间："
            :required="editType"
            v-model="invoiceData.accountTime"
            @click="TimePicker"
            :is-link="editType"
            :placeholder="editType ? '请选择' : ''"
            class="ggInput"
            readonly
          />
        </van-cell-group>
      </li>
    </ul>
    <div class="claimDetailLists list">
      <h4 class="title">借款人基本信息</h4>
    </div>
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.applicantIdName"
          input-align="right"
          readonly
          label="借款人："
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary dwBox">
        <van-field
          v-model="propertyData.amount"
          class="ggInput"
          input-align="right"
          readonly
          type="number"
          v-enterIntNumber
          label="申请金额（元）："
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.purpose"
          class="ggInput"
          input-align="right"
          readonly
          rows="1"
          autosize
          type="textarea"
          label="借款用途："
        />
      </van-cell-group>
      <!-- 附件 -->
      <!-- 微信的附件 避免和原生交互 -->
      <wx-file-view
        v-if="is_weixn"
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="propertyData"
        :editType="editType"
        @changeFile="changebaseAnnexes"
        class="fileview"
      ></file-view>
    </div>
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 弹出框 -->
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { dateFormat, isEdit, dateTimeFormat } from "@/utils/common";
import { getDeviceType, closePage,is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "returnJk",
  data() {
    return {
      propertyData: {
        applicantIdName: "", //名称
        amount: "", //借款金额
        purpose: "", //借款用途
        verifyStatus: "hold",
        baseAnnexes: [], //附件
      },
      invoiceData: {
        accountTime: "", //到账时间
        onceAmount: "", //本次到账金额
        amount: "", //借款金额
        amountTotal: "", //累计归还金额
        amountRemain: "", //未归还金额
      },
      anountInfoId: "",
      mode: "add",
      orgId: "",
      delPower: "",
      delType: false,
      editType: false,
      refreshPage: false, // 网络请求失败时显示
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2015, 1, 1),
      clientType: getDeviceType(), //手机类型
      is_weixn:is_wei(),//是否为微信
    };
  },
  components: {   
    fileView,
    wxFileView,
  },
  mounted() {
    if(is_wei()){    
      document.title="财务借款回款";
    }
    this.commonId = this.$route.query.commonId; //借款申请Id
    this.orgId = this.$route.query.orgId; //机构Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.delPower = this.$route.query.delPower || ""; //财务撤回权限
    this.delType = this.delPower == "true" ? true : false;
    this.editType = this.mode == "add" ? true : false;

    this.initPage();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      this.getDetail();
      this.getByJkMsg();
    },
    getDetail() {
      let _this = this;
      this.setShowLoad(false);
      _this.$api.finance.borrow
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //监测附件方法
    changebaseAnnexes(data) {
      this.propertyData.baseAnnexes = data;
    },
    getByJkMsg() {
      let _this = this;
      _this.$api.finance.account
        .viewAmount({ relationId: _this.commonId, accountType: "jk" })
        .then((res) => {
          if (res.code == "1") {
            _this.invoiceData = newApi.assign({}, _this.invoiceData, res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    moneyOnceChange() {
      if (
        parseFloat(this.invoiceData.amountRemain) -
          parseFloat(this.invoiceData.onceAmount) <
        0
      ) {
        this.$set(this.invoiceData, "onceAmount", "");
        this.$toast("本次到账金额不能大于未到账金额");
      }
    },
    jumpUrl() {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      if (
        this.invoiceData.amountTotal == "0" ||
        this.invoiceData.amountTotal == ""
      ) {
        return;
      } else {
        Url =
          Url +
          "/OA-pageH5/#/delHkList?token=" +
          token +
          "&commonId=" +
          this.commonId +
          "&commonType=jk&orgId=" +
          this.orgId +
          "&pageType=1";
        if (this.clientType == "android") {
          window.android.getInfo(112, Url);
        } else {
          //IOS
          console.log(Url);
          window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
        }
        // }
      }
    },
    //时间弹框
    TimePicker() {
      if (this.editType) {
        this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;

      this.invoiceData.accountTime = dateTimeFormat(data);
    },
    checkInput() {
      if (
        this.invoiceData.onceAmount == "" ||
        this.invoiceData.onceAmount == "0" ||
        this.invoiceData.accountTime == ""
      ) {
        this.$toast("带星号为必填，不能为空或0");
      } else {
        this.saveDzPrice();
      }
    },
    saveDzPrice() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.finance.account
        .returnBorrow({
          relationId: _this.commonId,
          amount: parseFloat(_this.invoiceData.onceAmount),
          accountTime: _this.invoiceData.accountTime,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            let text = "提交成功";
            closePage(text);
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.returnJkPage {
  width: 100%;
  min-height: 100%;
  background-color: #f6f6f6;
  .title {
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
  }
  .title:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 21px;
    background: #2581d6;
    top: 12px;
    left: 16px;
  }
  .wrap {
    padding-bottom: 80px;
  }
  .ljdz {
    border-bottom: 1px solid #f6f6f6;
  }
  .baseNone::after {
    content: none;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone {
    border-bottom: 1px solid #f6f6f6;
  }
  .baseNone.beizhu {
    min-height: 25px;
  }
  .listUl {
    width: 100%;
    background-color: #fff;
  }
  .listLi {
    align-items: flex-end;
    padding-bottom: 10px;
  }

  .claimDetailLists {
    border-bottom: 1px solid #f6f6f6;
    background-color: #fff;
  }
  .dzfp.claimDetailLists {
    margin-top: 10px;
  }
  .dwBox {
    .ggInput {
      .van-cell__title {
        width: 180px;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
}
</style>